import script from "./TermsOfUseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsOfUseModal.vue?vue&type=script&setup=true&lang=ts"

import "./TermsOfUseModal.vue?vue&type=style&index=0&id=3983a526&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3983a526"]])

export default __exports__